import {isNotNil} from 'ramda';

import {omneticApi} from '@dms/api/base';

import {
  GetTitleExtensionSuggestionApiArg,
  TitleExtensionSuggestionResponse,
  TitleExtensionSuggestionResponseSchema,
} from './types';

export const titleExtensionSuggestionApi = omneticApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    // Deterministic and stateless — it composes the text from the vehicle's equipment and
    // the tenant's short-name list, and persists nothing. Intentionally untagged: the
    // caller is a lazy query whose trigger refetches by default, so a dictionary edited
    // in Settings is picked up on the next click without any invalidation wiring.
    //
    // Kept in its own folder rather than alongside the other publishing-vehicle endpoints
    // in `salesPublishing/api.ts` only to avoid growing that already-large module; this is
    // a separate resource from the tenant-scoped `titleExtensionEquipment` dictionary.
    getTitleExtensionSuggestion: build.query<
      TitleExtensionSuggestionResponse,
      GetTitleExtensionSuggestionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/sales/publishing/vehicle/${encodeURIComponent(queryArg.vehicleId)}/title-extension/suggestion`,
        params: {
          ...(isNotNil(queryArg.language) ? {language: queryArg.language} : {}),
          ...(isNotNil(queryArg.currentValue) ? {currentValue: queryArg.currentValue} : {}),
        },
      }),
      extraOptions: {
        responseSchema: TitleExtensionSuggestionResponseSchema,
      },
    }),
  }),
});

export const {useLazyGetTitleExtensionSuggestionQuery} = titleExtensionSuggestionApi;
